import {Suspense} from 'react'
import {connect} from 'react-redux'

import {openDialog} from '../../../../actions'
import type {State} from '../../../../reducers/types'
import {getBuildComment, getBuildType} from '../../../../selectors'

import BuildComment from './BuildComment'
import type {OwnProps, Props, StateProps} from './BuildComment.types'

const actionCreators = {
  openDialogAction: openDialog,
}

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {text, buildTypeId, user, timestamp} = getBuildComment(state, props.buildId) || {}
  const {projectId} = getBuildType(state, buildTypeId) || {}
  return {
    user,
    text,
    timestamp,
    buildTypeId,
    projectId,
  }
}

export default connect(
  mapStateToProps,
  actionCreators,
)(function BuildCommentContainer(props: Props) {
  return (
    <Suspense>
      <BuildComment {...props} />
    </Suspense>
  )
})
